import {FormControl, InputAdornment, InputLabel, OutlinedInput} from '@mui/material';
import React, {useState} from 'react';

const NumericInput = props => {
    const [value, setValue] = useState(props.value);

    const update = () => {
        const numericValue = parseFloat(value);
        if(!isNaN(numericValue)){
            props.updateValue(numericValue);
            setValue(numericValue);
        }else{
            setValue(props.value);
        }
    }

    return(
        <FormControl
            fullWidth
            variant={'outlined'}
        >
            <InputLabel id={props.label}>{props.label}</InputLabel>
            <OutlinedInput
                id={props.label}
                label={props.label}
                value={value}
                inputProps={{type: 'number', precision: props.precision, step: props.step}}
                endAdornment={<InputAdornment position={'end'}>{props.unit}</InputAdornment>}
                onChange={event => setValue(event.target.value)}
                onBlur={update}
                onKeyDown={event => {
                    if(event.code === 'Enter'){
                        update();
                    }
                }}
                onFocus={event => event.target.select()}
            />
        </FormControl>
    );
}

export default NumericInput;